'use client';

import { Box, Radio, RadioGroup, Typography } from '@wishket/design-system';
import { ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';

import { Icon, IconName } from '../Icon';

interface WideRadioCardProps {
  className?: string;
  name?: string;
  value?: string;
  label?: string;
  leadingIcon?: IconName;
  isSelected?: boolean;
  selectedValue?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const WideRadioCardItem = ({
  name,
  className,
  value,
  label,
  leadingIcon,
  isSelected,
  onChange,
}: WideRadioCardProps) => {
  return (
    <label
      className={twMerge(
        'group flex w-full shrink-0 cursor-pointer items-center gap-3 rounded-xl border border-w-gray-200 p-4 hover:border-primary',
        isSelected && 'border-primary bg-primary-10',
        className
      )}
    >
      <Radio
        isSelected={isSelected}
        name={name}
        value={value}
        onChange={onChange}
      />
      {leadingIcon && <Icon name={leadingIcon} />}
      <Typography variant="body1" className="shrink-0">
        {label}
      </Typography>
    </label>
  );
};

interface WideRadioCardListProps {
  selectedValue: string;
  items: {
    label: string;
    value: string;
    isSelected: boolean;
    leadingIcon: IconName;
  }[];
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const WideRadioCardGroup = ({
  selectedValue,
  items,
  onChange,
}: WideRadioCardListProps) => {
  // TODO: 모바일일 때에 "간식", 다른 경우에는 "간식 시간"으로 뜨도록 처리
  return (
    <Box className="flex w-full flex-wrap gap-4">
      <RadioGroup
        name="habit"
        data={items}
        selectedValue={selectedValue}
        onChange={onChange}
      >
        {(item) => (
          <WideRadioCardItem
            className="w-[calc(50%_-_8px)]"
            key={item.value}
            {...item}
          />
        )}
      </RadioGroup>
    </Box>
  );
};

export default WideRadioCardGroup;
